import { createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
import { spacing } from './spacing';
import { components } from './components';
import { shadows as customShadows } from './shadows';

export const theme = createTheme({
  palette,
  typography,
  spacing,
  components,
  shadows: customShadows,
  shape: { borderRadius: 2 },
});
